import { User } from "../users";
import { WorkspaceDump } from "./workspace-dump";
import { z } from "zod";
export const UserDump = z.object({
    user: User,
    workspaces: WorkspaceDump.array(),
});
